import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Typography, Box, IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { MdEmail } from 'react-icons/md';
import { SiDiscord } from 'react-icons/si';

const DISCORD_LINK = "https://discord.gg/xE2THMamFP";

const ContactDialog = ({ open, onClose }) => {
  const [copiedDiscord, setCopiedDiscord] = useState(false);
  const [copiedEmail, setCopiedEmail] = useState(false);

  const EMAIL = "contact@gt-telemetry.com";

  const handleCopyDiscord = () => {
    navigator.clipboard.writeText(DISCORD_LINK);
    setCopiedDiscord(true);
    setTimeout(() => setCopiedDiscord(false), 1500);
  };

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(EMAIL);
    setCopiedEmail(true);
    setTimeout(() => setCopiedEmail(false), 1500);
  } 

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Contact Us</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Questions, feedback, or support? Get in touch:
        </DialogContentText>
        <Box sx={{ mt: 2 }} />
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Typography variant="body1" sx={{ wordBreak: 'break-all', color: '#0072CE', fontWeight: 700, display: 'flex', alignItems: 'center' }}>
            <MdEmail style={{ marginRight: 6, fontSize: 22, verticalAlign: 'middle' }} />
            {EMAIL}
          </Typography>
          <Tooltip title={copiedEmail ? "Copied!" : "Copy email"}>
            <IconButton onClick={handleCopyEmail} sx={{ ml: 1 }} size="small">
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Typography variant="body1" sx={{ wordBreak: 'break-all', color: '#5865F2', fontWeight: 700, display: 'flex', alignItems: 'center' }}>
            <SiDiscord style={{ marginRight: 6, fontSize: 22, verticalAlign: 'middle' }} />
            <a href={DISCORD_LINK} target="_blank" rel="noopener noreferrer" style={{ color: '#5865F2', textDecoration: 'none' }}>
              Discord Server
            </a>
          </Typography>
          <Tooltip title={copiedDiscord ? "Copied!" : "Copy link"}>
            <IconButton onClick={handleCopyDiscord} sx={{ ml: 1 }} size="small">
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained" autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactDialog;